import zh from './zh/zh'
import en from './en/en'
import zhTw from './zh-tw/zh-tw';
import th from './th/th' // 泰语

export default {
   zh,
   zhTw,
   en,
   th
}; //将i18n暴露出去，在main.js中引入挂载

